module.exports = __webpack_public_path__ + "static/media/Milex-Ring-Pessary-Instructions-for-Use@2x.f1de93b3.jpg";